import apiClient from "../apiClient";

const resource = "reports";

export default {
    getVacations: params => apiClient.get(`${resource}/vacations?${params}`),   
    getEmployeesJobs: params => apiClient.get(`${resource}/employeesJobs?${params}`),   
    getBonuses: params => apiClient.get(`${resource}/bonuses?${params}`),   
    getCorrelator: params => apiClient.get(`${resource}/correlator?${params}`),   
    getRetirement: params => apiClient.get(`${resource}/Retirement?${params}`),   
    getEmployeesJobGrades: params => apiClient.get(`${resource}/EmployeesJobGrades?${params}`),   
    getEmployeesQualifications: params => apiClient.get(`${resource}/EmployeesQualifications?${params}`),   
    getEmployeeCourses: params => apiClient.get(`${resource}/EmployeeCourses?${params}`),   
    getBonusStatment: id => apiClient.get(`${resource}/${id}/bonusStatment`),   
};